export const formatRows = (listaItems) => 
    listaItems.map((item) => ({
      id: item.id,
      nombre: item.nombre,
      descripcion: item.descripcion,
    }));
  